import FaqPageContainer from '@/app/components/FaqPageComponents/FaqPageContainer';
import { TERMS_DATA } from '@/app/pages/TermOfServicePage/terms-data';
import { Accordion } from '@/app/shared/ui/Accordion';

const TermOfServicePage = () => {
  return <FaqPageContainer centerContent={<Accordion items={TERMS_DATA} />} heading='Terms Of Service' />;
};

export default TermOfServicePage;
